'use strict';

const _ = require('lodash');

const base = {
  env: {
    NODE_ENV: process.env.NODE_ENV || 'development'
  },
  // Auth config can either be set with env variables or in e.g. staging.js in the same object format as below
  auth: {
    AUTH0_DOMAIN: 'escio.eu.auth0.com',
    AUTH0_CLIENT_ID: 'b7e2oUsSFGlrflbWMm2nC66nP6Jsh0iI',
    AUTH0_REDIRECT_URL: 'http://localhost:8000'
  },
  campaigns: {
    mfRotation: {
      startYear: 2019,
      startMonth: 6, // Note: January is 0, February is 1, and so on. See JavaScript setMonth()
      startDay: 1,
      toggleDays: 14,
      makes: ['hongqi', 'mitsubishi', 'renault', 'dongfeng', 'voyah', 'changan']
    }
  }
};

// _.merge(base, require(`./${base.env.NODE_ENV}`));
_.merge(base, require('./' + base.env.NODE_ENV)); // eslint-disable-line

try {
  _.merge(base, require('./' + base.env.NODE_ENV + '.user')); // eslint-disable-line
} catch (e) {
  if (e.code !== 'MODULE_NOT_FOUND') {
    throw e;
  }
}

// console.log(`Admin application running using ${base.env.NODE_ENV.toUpperCase()} environment.`);
console.log('Admin application running using ' + base.env.NODE_ENV.toUpperCase() + ' environment.'); // eslint-disable-line

module.exports = base;
